import type { Action } from "@reduxjs/toolkit";
import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import type { UiSettingsActionTypes, UiSettingsState } from "../types/uiSettingsState.types";
import { UI_SETTINGS_SLICE_NAME } from "../utils/storeUtils";
import { versionHistorySlice } from "./versionHistorySlice";

const initialState: UiSettingsState = {
  builderSelectedTab: "Fields",
  dragSessionId: "",
  versionHistoryOpen: false,
  editDisabled: false,
};
export const uiSettingsSlice = createSlice({
  name: UI_SETTINGS_SLICE_NAME,
  initialState: initialState,
  reducers: {
    setTab: (state, action: UiSettingsActionTypes["setTab"]) => {
      state.builderSelectedTab = action.payload;
    },
    setDragSessionId: (state, action: UiSettingsActionTypes["setDragSessionId"]) => {
      state.dragSessionId = action.payload;
    },
    setVersionHistoryOpen: (state, action: UiSettingsActionTypes["setVersionHistoryOpen"]) => {
      state.versionHistoryOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action: Action) => action.type === `${UI_SETTINGS_SLICE_NAME}/setDragSessionId`,
      (state) => {
        state.builderSelectedTab = "Fields";
      }
    );
    builder.addMatcher(isAnyOf(versionHistorySlice.actions.updatePreviewConfiguration), (state, action) => {
      state.editDisabled = action.payload !== undefined;
    });
  },
});

export default uiSettingsSlice.reducer;
